import React from 'react';
import { Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { FilterButton } from '@/components/FilterButton';
import DatePicker, { DatePickerMode } from '@/components/DatePicker';
import type { DateRange } from 'react-day-picker';

interface ReportsListFiltersProps {
  search: string;
  onSearchChange: (_value: string) => void;
  onApplySearch: () => void;
  onClearSearch: () => void;
  dateRange: DateRange | undefined;
  onDateRangeChange: (_range: DateRange | undefined) => void;
  partnerFilter: string;
  partnerOptions: Array<{ value: string; label: string }>;
  onPartnerFilterChange: (_value: string) => void;
}

export const ReportsListFilters: React.FC<ReportsListFiltersProps> = ({
  search,
  onSearchChange,
  onApplySearch,
  onClearSearch,
  dateRange,
  onDateRangeChange,
  partnerFilter,
  partnerOptions,
  onPartnerFilterChange,
}) => (
  <div className="flex flex-wrap items-center gap-3">
    <div className="flex flex-wrap items-center gap-3 ml-auto">
      <div className={`relative ${(dateRange?.from || dateRange?.to) ? 'pl-9' : ''}`}>
        {(dateRange?.from || dateRange?.to) && (
          <button
            type="button"
            onClick={() => onDateRangeChange(undefined)}
            className="absolute left-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-muted text-muted-foreground hover:text-foreground z-10"
            aria-label="Limpar filtro de data"
          >
            <X className="h-4 w-4" />
          </button>
        )}
        <DatePicker
          value={dateRange}
          onChange={(range) => onDateRangeChange(range as DateRange)}
          mode={DatePickerMode.Range}
          placeholder=""
          className="h-10 sm:h-9 text-xs w-auto"
        />
      </div>
      <div className="relative flex-1 sm:flex-none sm:w-64 lg:w-72 flex gap-2">
        <div className="relative flex-1 min-w-0">
          <Input
            placeholder="Pesquisar"
            value={search}
            className={'w-full h-10 sm:h-9 pr-9'}
            iconLeft={<Search className="h-4 w-4 stroke-muted-foreground" />}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onApplySearch()}
          />
          {search.trim() ? (
            <button
              type="button"
              onClick={onClearSearch}
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-muted text-muted-foreground hover:text-foreground"
              aria-label="Limpar pesquisa"
            >
              <X className="h-4 w-4" />
            </button>
          ) : null}
        </div>
        <Button
          size="sm"
          variant="dark"
          onClick={onApplySearch}
          className="h-10 sm:h-9 px-4 shrink-0"
        >
          OK
        </Button>
      </div>
      <FilterButton
        label="Filtrar por Marca"
        value={partnerFilter}
        onValueChange={onPartnerFilterChange}
        options={partnerOptions}
        className="w-full sm:w-auto h-10 sm:h-9"
      />
    </div>
  </div>
);
